//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scholingseditiePosts from '~/graphql/queries/scholingseditiePosts.gql';

export default {
  auth: false,
  apollo: {
    scholingseditiePosts: {
      query: scholingseditiePosts,
      throttle: 500,
      debounce: 150,
      variables() {
        return {
          page: this.page,
          per_page: this.perPage,
          query: this.query.length ? this.query : null,
        };
      },
      result(data) {
        if (this.filtersChanged) {
          this.filtersChanged = false;
          this.posts = [];
        }

        if (data.data.scholingseditiePosts && data.data.scholingseditiePosts.length) {
          data.data.scholingseditiePosts.forEach((post) => {
            if (!this.posts.includes(post)) {
              this.posts.push(post);
            }
          });
          this.moreAvailable = data.data.scholingseditiePosts.length >= this.perPage;
        } else {
          this.moreAvailable = false;
        }
        this.pages++;
      },
    },
  },
  data() {
    return {
      placeholderImage: require('~/assets/img/post_placeholder.png'),
      scholingseditiePosts: {},
      posts: [],
      page: 1,
      perPage: 10,
      moreAvailable: true,
      vakgroepen: [],
      filtersChanged: false,
      query: '',
    };
  },
  methods: {
    loadMore() {
      if (this.moreAvailable) {
        this.page++;
      }
    },
    setFiltersChanged() {
      this.page = 1;
      this.filtersChanged = true;
    },
  },
};
